<template>
  <div
    class="power-bi-upbuttons"
    @mouseenter="upHere = true"
    @mouseleave="upHere = false"
  >
    <div class="list-group">
      <transition name="fade" mode="out-in">
        <button
          @click.prevent="collapseAction('expand')"
          v-if="upHere"
          type="button"
          class="list-group-item list-group-item-action"
          aria-current="true"
        >
          Expand
        </button>
      </transition>
      <transition name="fade" mode="out-in">
        <button
          @click.prevent="collapseAction('collapse')"
          v-if="upHere"
          type="button"
          class="list-group-item list-group-item-action"
        >
          Collapse
        </button>
      </transition>
      <transition name="fade" mode="out-in">
        <button
          @click.prevent="upPage"
          type="button"
          class="
            list-group-item list-group-item-action
            bg-light
            font-weight-bold
          "
        >
          Up
        </button>
      </transition>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/util/eventbus";

export default {
  data() {
    return {
      upHere: false,
    };
  },
  methods: {
    upPage() {
      window.scrollTo({ top: 0, y: 0, behavior: "smooth" });
    },
    collapseAction(type) {
      EventBus.$emit("collapsed", type);
    },
  },
};
</script>

<style>
</style>